import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m13 13 1.5-.402V5L8 1.5 1.5 5v9.5h11.902L13 13Zm0 0H3V5.896l5-2.692 5 2.692V13Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m9.604 11.804-.452-.599c-.406-.539-.928-1.878.004-3.091.497-.647-.024-1.444-.029-1.452L8.71 6.04l1.248-.833.416.623c.42.628.886 2.009-.029 3.199a.934.934 0 0 0-.179.855c.061.24.182.417.184.419l.451.598-1.197.903v.001ZM6.102 11.804l-.452-.599c-.405-.539-.928-1.878.004-3.091.498-.647-.023-1.444-.029-1.452L5.21 6.04l1.248-.833.416.623c.42.628.885 2.009-.029 3.199a.934.934 0 0 0-.179.855c.06.24.182.417.183.419l.452.598-1.198.903v.001Z"
        }
      )
    ]
  }
);
export {
  t as WarmHome
};
